<template>
  <form>
    <b-button class="mb-4 mt-1" variant="success" size="lg" v-b-modal.new_ticket_modal>
      <font-awesome-icon class="mr-2" :icon="['fas', 'plus']" />
      Afegir incidència
    </b-button>
    <!-- Modal Component -->
    <b-modal id="new_ticket_modal" size="md" centered ref="new_ticket_modal" title="Afegir nova incidència">
      <b-container class="text-center">
        <CategoryGroupIncidenceSelects
          :reset="reset"
          @reseted="childVal => {  this.reset = childVal.reset }"
          @changeCategory="childVal => {  this.category = childVal.category }"
          @changeIncidence="childVal => {  this.incidence = childVal.incidence }"/>
        <b-container>
          <span v-if="[2,8,9].includes(this.category)">
            <div class="mb-3">Espai*:</div>
            <v-select
              :options="classes_select"
              v-model="classroom"
              placeholder="-- Selecciona un espai --"
              class="mb-3"/>
          </span>
          <div class="mb-3">Detalls*:</div>
          <b-form-textarea id="textarea2" class="mb-3"
          v-model="details"
          placeholder="Explicació del problema"
          :rows="6"/>
          <div class="mb-3">Fitxers:</div>
          <AddFiles @updateFiles="childVal => {
              this.files = childVal.files
            }" class="mb-3"/>
          <b-form-checkbox v-if="this.user.userRole === 'Critical' || this.user.userRole === 'Manager'"
            v-model="critical">
            Afegir com a crítica
          </b-form-checkbox>
        </b-container>
      </b-container>
      <div slot="modal-footer" class="w-100">
        <b-btn class="float-right" variant="primary" @click.prevent="save()">
          <font-awesome-icon :icon="['fas', 'check']"/>
          Afegir
        </b-btn>
      </div>
    </b-modal>
  </form>
</template>

<script>

import CategoryGroupIncidenceSelects from '@/components/CategoryGroupIncidenceSelects'
import AddFiles from '@/components/AddFiles'

export default {
  components: {
    CategoryGroupIncidenceSelects,
    AddFiles
  },
  computed: {
    classrooms () {
      return this.$store.state.classrooms
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  data () {
    var dades = this.getDefaultData()
    dades['classes_select'] = []
    return dades
  },
  methods: {
    getDefaultData () {
      return {
        // Información escogida por el usuario
        incidence: null,
        classroom: null,
        details: '',
        reset: false,
        files: '',
        critical: false,
        category: null
      }
    },
    save () {
      if (this.isNullOrUndefined(this.incidence)) {
        this.notifyError('Falta informació', 'Els camp incidència és necessari')
      } else if (this.isNullOrUndefined(this.details)) {
        this.notifyError('Falta informació', 'Els camp detalls és necessari')
      } else if (this.category === 2 && this.isNullOrUndefined(this.classroom)) {
        this.notifyError('Falta informació', 'Els camp aula és necessari')
      } else {
        var formData = new FormData()
        if (this.critical === true && (this.user.userRole === 'Critical' || this.user.userRole === 'Manager')) {
          formData.append('critical', true)
        }
        if (this.classroom && this.classroom['value']) {
          formData.append('classroom', this.classroom['value'])
        }
        formData.append('incidence_id', this.incidence)
        formData.append('user', this.user.id)
        formData.append('details', this.details)

        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i]
          formData.append(file.name, file)
        }

        // Cerramos el modal
        this.$refs.new_ticket_modal.hide()
        // Llamamos a la api
        this.$store.dispatch('createTicket', formData)
        // Reiniciamos el modal
        Object.assign(this.$data, this.getDefaultData())
        this.reset = true
      }
    }
  },
  created () {
    // Cogemos las clases y las formateamos para que se vean en el select
    this.$store.dispatch('fetchClassrooms').then(() => {
      this.classes_select = this.classrooms.filter(classe => classe.descripcio != null).map(classe =>
        ({
          value: classe['aula'],
          label: `${classe['aula']} - ${classe['descripcio']}`
        }))
      return this.classes_select
    }, {})
  }
}
</script>

<style scoped>
</style>
